import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import ProductTypePage from '../components/ProductTypePage/ProductTypePage';
import Layout from '../components/UI/Layout/Layout';
import useApiSchema from '../hooks/useApiSchema';
import AvatarAncEvery2HoursPage from './AvatarAncEvery2HoursPage';
import AvatarAncPage from './AvatarAncPage';
import AvatarAncV2Page from './AvatarAncV2Page';
import DashboardPage from './DashboardPage';
import {
    ancs,
    ancsEvery2Hours,
    ancsV2,
    dashboard,
    index,
    index_no_token,
    login,
    prestataires,
    product_types,
    root,
    thresholds,
    types,
    unauthorized,
} from './paths';
import LoginPage from './LoginPage';
import PrestatairesPage from './PrestatairesPage';
import RefreshTokenPage from './RefreshTokenPage';
import ThresholdPage from './ThresholdPage';
import TypesPage from './TypesPage';

const RootPage = () => {
    const isApiSchemaLoading = useApiSchema();

    return (
        <Layout>
            {(!isApiSchemaLoading && (
                <Switch>
                    <Route exact path={root} render={() => <Redirect to={login} />} />
                    <Route exact path={unauthorized} render={() => <Redirect to={login} />} />
                    <Route exact path={login} component={(props: any) => <LoginPage {...props} />} />
                    <Route exact path={index_no_token} component={(props: any) => <LoginPage {...props} />} />
                    <Route exact path={index} component={(props: any) => <RefreshTokenPage {...props} />} />
                    <Route exact path={dashboard} component={(props: any) => <DashboardPage {...props} />} />
                    <Route exact path={thresholds} component={(props: any) => <ThresholdPage {...props} />} />
                    <Route exact path={ancs} component={(props: any) => <AvatarAncPage {...props} />} />
                    <Route
                        exact
                        path={ancsEvery2Hours}
                        component={(props: any) => <AvatarAncEvery2HoursPage {...props} />}
                    />
                    <Route exact path={ancsV2} component={(props: any) => <AvatarAncV2Page {...props} />} />
                    <Route exact path={types} component={(props: any) => <TypesPage {...props} />} />
                    <Route exact path={product_types} component={(props: any) => <ProductTypePage {...props} />} />
                    <Route exact path={prestataires} component={(props: any) => <PrestatairesPage {...props} />} />
                    {/*<Route exact path={map_avatars_v2} component={(props: any) => <MapAvatarsv2Page {...props} />} />*/}
                </Switch>
            )) || <></>}
        </Layout>
    );
};

export default RootPage;
